export default __webpack_public_path__ + "static/img/15.ea61be2.png";